import { useQuery } from 'react-query';

import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DealReducedFeeLender } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useReducedFeeLendersQuery(guid: string | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.ReducedFeeLenders(guid),
		() =>
			AxiosUtils.getResponseData<DealReducedFeeLender[]>(
				api.get(CerebroApiEndpoints.ReducedFeeLenders.Root(guid))
			),
		{
			enabled: guid !== undefined,
		}
	);
}
